import axios from "axios";

import { INCREMENT, DECREMENT, DEVIDE, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, CLEAR_AUTH_ERROR, SESSION_EXTENDED, AUTH_INITIALIZED } from "./types";

export const increaseCounter = (data) => {
  return {
    type: INCREMENT,
    payload: { name: "Nguyen Van A", data: data },
  };
};

export const decreaseCounter = () => {
  return {
    type: DECREMENT,
  };
};

export const devideCounter = () => {
  return {
    type: DEVIDE,
  };
};

// Authentication actions
export const loginUser = (username, password) => {
  return (dispatch) => {
    // Check admin credentials
    if (username === 'admin' && password === 'admin123') {
      const now = new Date();
      const expirationTime = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days from now
      
      const user = {
        id: 1,
        username: 'admin',
        role: 'admin',
        loginTime: now.toISOString(),
        expirationTime: expirationTime.toISOString()
      };
      
      // Store in localStorage for persistence with expiration
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('authExpiration', expirationTime.toISOString());
      
      dispatch({
        type: LOGIN_SUCCESS,
        payload: user
      });
      
      return Promise.resolve(user);
    } else {
      const error = 'Invalid username or password';
      dispatch({
        type: LOGIN_FAILURE,
        payload: error
      });
      
      return Promise.reject(error);
    }
  };
};

export const loginWithGoogle = (googleUser) => {
  return (dispatch) => {
    const now = new Date();
    const expirationTime = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days from now
    
    const user = {
      id: googleUser.id || Date.now(),
      username: googleUser.name || googleUser.email,
      email: googleUser.email,
      role: 'user',
      loginTime: now.toISOString(),
      expirationTime: expirationTime.toISOString(),
      provider: 'google'
    };
    
    // Store in localStorage for persistence with expiration
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('authExpiration', expirationTime.toISOString());
    
    dispatch({
      type: LOGIN_SUCCESS,
      payload: user
    });
    
    return Promise.resolve(user);
  };
};

export const logoutUser = () => {
  return (dispatch) => {
    // Clear localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('authExpiration');
    
    dispatch({
      type: LOGOUT
    });
  };
};

export const clearAuthError = () => {
  return {
    type: CLEAR_AUTH_ERROR
  };
};

export const initializeAuth = () => {
  return (dispatch) => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    const userStr = localStorage.getItem('user');
    const authExpiration = localStorage.getItem('authExpiration');
    
    if (isAuthenticated && userStr && authExpiration) {
      try {
        const user = JSON.parse(userStr);
        const expirationDate = new Date(authExpiration);
        const now = new Date();
        
        // Check if session has expired
        if (now >= expirationDate) {
          // Session expired, logout
          dispatch(logoutUser());
          return;
        }
        
        // Session is still valid
        dispatch({
          type: LOGIN_SUCCESS,
          payload: user
        });
        
        // Set up auto-logout when session expires
        const timeUntilExpiration = expirationDate.getTime() - now.getTime();
        if (timeUntilExpiration > 0) {
          setTimeout(() => {
            dispatch(logoutUser());
          }, timeUntilExpiration);
        }
        
      } catch (error) {
        // If user data is corrupted, logout
        dispatch(logoutUser());
      }
    } else {
      // No valid authentication found, mark as initialized
      dispatch({
        type: AUTH_INITIALIZED
      });
    }
  };
};

// Check if session is still valid
export const checkAuthValidity = () => {
  return (dispatch) => {
    const authExpiration = localStorage.getItem('authExpiration');
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    
    if (isAuthenticated && authExpiration) {
      const expirationDate = new Date(authExpiration);
      const now = new Date();
      
      if (now >= expirationDate) {
        // Session expired, logout
        dispatch(logoutUser());
        return false;
      }
      return true;
    }
    return false;
  };
};

// Extend session by 7 days (useful for "remember me" functionality)
export const extendSession = () => {
  return (dispatch) => {
    const userStr = localStorage.getItem('user');
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    
    if (isAuthenticated && userStr) {
      try {
        const user = JSON.parse(userStr);
        const now = new Date();
        const newExpirationTime = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days from now
        
        const updatedUser = {
          ...user,
          expirationTime: newExpirationTime.toISOString()
        };
        
        // Update localStorage
        localStorage.setItem('user', JSON.stringify(updatedUser));
        localStorage.setItem('authExpiration', newExpirationTime.toISOString());
        
        dispatch({
          type: LOGIN_SUCCESS,
          payload: updatedUser
        });
        
        // Set up new auto-logout timer
        const timeUntilExpiration = newExpirationTime.getTime() - now.getTime();
        setTimeout(() => {
          dispatch(logoutUser());
        }, timeUntilExpiration);
        
        // Show success toast
        if (window.showToast) {
          window.showToast('[SESSION_EXTENDED] ✓ 7 ngày đã được thêm vào phiên đăng nhập', 'success', 4000);
        }
        
      } catch (error) {
        // Show error toast
        if (window.showToast) {
          window.showToast('[ERROR] Không thể gia hạn phiên đăng nhập', 'error', 3000);
        }
        dispatch(logoutUser());
      }
    }
  };
};
